"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var Checkbox = function (_a) {
    var onChange = _a.onChange, _b = _a.checked, checked = _b === void 0 ? false : _b, _c = _a.csx, csx = _c === void 0 ? {} : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, restProps = __rest(_a, ["onChange", "checked", "csx", "disabled"]);
    return (theme_ui_1.jsx("input", __assign({ type: "checkbox", disabled: disabled, checked: checked, onChange: onChange, sx: __assign({ position: "relative", width: "28px", height: "28px", flexShrink: 0, m: 0, mr: 2, cursor: "pointer", appearance: "none", border: "2px solid", borderColor: __1.theme.colors.grey900, "::before": {
                background: __1.theme.colors.white,
                clipPath: "polygon(21% 38%, 40% 58%, 80% 18%, 91% 30%, 40% 81%, 9% 50%)",
                content: "''",
                width: "100%",
                height: "100%",
                pointerEvents: "none",
                position: "absolute",
                transform: "scale(0)"
            }, ":checked::before": {
                transform: "scale(1)"
            }, ":disabled": {
                cursor: "not-allowed",
                filter: "grayscale(1)",
                "::before": {
                    background: __1.theme.colors.grey800
                }
            }, ":focus": {
                outline: "none"
            } }, csx) }, restProps)));
};
exports.Checkbox = Checkbox;
